import { render, staticRenderFns } from "./SubtitlesSegment.vue?vue&type=template&id=7a299b60&scoped=true"
import script from "./SubtitlesSegment.vue?vue&type=script&lang=js"
export * from "./SubtitlesSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a299b60",
  null
  
)

/* custom blocks */
import block0 from "./SubtitlesSegment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports